import React from "react";
import INTERCOM_ARTICLES from "../../../../constants/intercomArticles";

export default function HinNotice(props) {
  return(
    (props.disableHinNotice || !props.hinMissing)
      ? null
      : <div className="stat-cards__notice" style={{ lineHeight: 1.5 }}>
        <span style={{ fontWeight: 500 }}>You can still save designations </span>
        but our records indicate the selected pharmacy does not have a HIN. You must register a HIN through&nbsp;
        <a href="https://www.hibcc.org/" target="_blank">
          <span style={{ fontWeight: 500, textDecoration: "underline" }}>HIBCC</span>
        </a>
        &nbsp;in order to ship 340B purchased drugs to this pharmacy.&nbsp;
        <a href={INTERCOM_ARTICLES.HOW_TO_OBTAIN_HIN} target="_blank">
          <span style={{ fontWeight: 500, textDecoration: "underline" }}>Learn more</span>
        </a>.
      </div>
  )
};
